// Shared style for every square icon button in the top bar (theme toggle,
// language, notifications, sign out) — mirrors the prototype's single
// `.topbar-btn` class exactly (34x34, 8px radius, translucent border/bg that
// brightens on hover) instead of each button drifting its own approximation.
export const TOPBAR_BTN_CLASS =
  'w-[34px] h-[34px] rounded-lg border border-white/[.22] bg-white/10 text-white/90 hover:text-white hover:bg-white/20 hover:border-white/[.42] flex items-center justify-center transition-colors'
